import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import Actions from '@mm/state/actions/actions';
import { getIsShopifyApp, setIsShopifyApp } from './helpers';

export const useShopifyEnv = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (getIsShopifyApp()) {
      setIsShopifyApp();

      window.MMApp = {
        loginUrl: 'https://admin.shopify.com',
        throwErrors: true,
      };

      dispatch({
        type: Actions.SET_APP_CONTEXT,
        payload: 'shopify',
      });
    }
  }, []);
};
